export const buildFilterUrl = (filter) => {
  return Object.keys(filter)
    .map((key) => {
      if (key === 'orderBy') {
        return filter.orderBy.map(
          (order) => `orderBy[]=${order.orderBy},${order.direction || 'asc'}`
        )
      }
      if (filter[key] === null || filter[key] === '') {
        return ''
      }
      return `${key}=${filter[key]}`
    })
    .join('&')
}
